import { useEffect, useState } from "react";

// A value that is still loading: ".", "..", "..." in turn, so a slow figure
// reads as on its way rather than stuck. Fixed width (three dots), so the
// card around it does not shift as it steps; still for reduced motion.
const FRAMES = [".", "..", "..."];
const STEP_MS = 400;

const prefersReducedMotion = () =>
  typeof window !== "undefined" &&
  window.matchMedia?.("(prefers-reduced-motion: reduce)").matches;

export default function LoadingDots({ label = "Loading" }) {
  const [frame, setFrame] = useState(FRAMES.length - 1);

  useEffect(() => {
    if (prefersReducedMotion()) return undefined;
    const id = setInterval(
      () => setFrame((f) => (f + 1) % FRAMES.length),
      STEP_MS,
    );
    return () => clearInterval(id);
  }, []);

  return (
    <span role="status" aria-label={label} className="inline-block w-[3ch]">
      <span aria-hidden="true">{FRAMES[frame]}</span>
    </span>
  );
}
